import styled from "styled-components";

export const PageTitle = styled.h1`
  font-family: var(--font-family-secondary);
  font-weight: 400;
  font-size: 2.625rem;
  line-height: 3rem;
  margin: 0;
`;

export const Heading1 = styled.h1`
  font-family: var(--font-family-secondary);
  font-weight: 500;
  font-size: 1.875rem;
  line-height: 2.5rem;
  margin: 0;
`;

export const Heading2 = styled.h2`
  font-family: var(--font-family-secondary);
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.875rem;
  margin: 0;
`;

export const Heading3 = styled.h3`
  font-family: var(--font-family-secondary);
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.375rem;
  margin: 0;
`;

export const Heading4 = styled.h4`
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin: 0;
`;
